// extracted by mini-css-extract-plugin
export default {"Project":"Project_Project__eY3rb","Visible":"Project_Visible__1Jpzj","Image":"Project_Image__7h-f2","Description":"Project_Description__n+FmG"};